module.exports = __webpack_public_path__ + "static/media/podcast.6ad7fdd6.png";